import React, { useEffect, useState } from "react";
import {
  browserTimeZone,
  formatDeadlineDay,
} from "../../../../utils/interviewExpiry";
import dayjs from "dayjs";
import WebUtils from "../../../../utils/WebUtils";
import {
  postReScheduleInterview,
  postScheduleInterview,
} from "../../../../api/candidate";

import { DatePicker, Input, message, notification } from "antd";
const disablePastDates = (current) => {
  // Disable dates before today
  return current && current.isBefore(dayjs().startOf("day"));
};

function CandidateInformation({
  interviewData,
  setInterviewData,
  interviewState,
  setInterviewState,
  editFlag,
  setEditFlag,
  step3Enabled,
  jdId,
  iDronaId,
  userDetail,
  setLoading,
}) {
  const [candidateName, setCandidateName] = useState(
    interviewData?.candidateName
  );
  const [candidateEmail, setCandidateEmail] = useState(
    interviewData?.candidateEmail
  );
  const [expiryDate, setExpiryDate] = useState(interviewData?.expiryDate);
  const [scheduledFlag, setScheduledFlag] = useState(false);

  const handleSchedule = async () => {
    if (!candidateName) {
      message.warning("Please fill in the candidate name!");
      return;
    }
    if (!candidateEmail) {
      message.warning("Please fill in the candidate email!");
      return;
    }
    if (!expiryDate) {
      message.warning("Please select an expiry date!");
      return;
    }

    const requestBody = {
      candidateName,
      candidateEmail,
      userIdentifier: userDetail?.userIdentifier,
      expiryDate,
      timeZone: browserTimeZone(),
      idronaInterviewId: iDronaId,
    };

    setLoading(true);
    try {
      const response = await WebUtils.httpOperations(
        `${postScheduleInterview}`,
        requestBody,
        "POST"
      );

      if (
        response.data.resultStatusInfo.resultCode.toLowerCase() === "success"
      ) {
        const data = response?.data?.data || null;
        setInterviewData(data);
        setInterviewState(data?.interviewState);
        setEditFlag(false);
        notification.success({
          message: "Success",
          description: "Mock interview scheduled successfully!",
        });
      } else {
        notification.error({
          message: "Failure",
          description: response.data.resultStatusInfo.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Failure",
        description: "Failed to schedule interview!",
      });
      console.error("Error fetching overview data:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleReSchedule = async () => {
    if (!candidateName) {
      message.warning("Please fill in the candidate name!");
      return;
    }
    if (!candidateEmail) {
      message.warning("Please fill in the candidate email!");
      return;
    }
    if (!expiryDate) {
      message.warning("Please select an expiry date!");
      return;
    }

    const requestBody = {
      candidateName,
      candidateEmail,
      userIdentifier: userDetail?.userIdentifier,
      expiryDate,
      timeZone: browserTimeZone(),
      idronaInterviewId: iDronaId,
    };

    setLoading(true);
    try {
      const response = await WebUtils.httpOperations(
        `${postReScheduleInterview}`,
        requestBody,
        "POST"
      );

      if (
        response.data.resultStatusInfo.resultCode.toLowerCase() === "success"
      ) {
        const data = response?.data?.data || null;
        setInterviewData(data);
        setInterviewState(data?.interviewState);
        setEditFlag(false);
        notification.success({
          message: "Success",
          description: "Mock interview rescheduled successfully!",
        });
      } else {
        notification.error({
          message: "Failure",
          description: response.data.resultStatusInfo.message,
        });
      }
    } catch (error) {
      notification.error({
        message: "Failure",
        description: "Failed to reschedule interview!",
      });
      console.error("Error fetching overview data:", error);
    } finally {
      setLoading(false);
    }
  };

  const isExpired = interviewState === "INTERVIEW_EXPIRED";

  useEffect(() => {
    if (
      interviewState === "INTERVIEW_SCHEDULED" ||
      interviewState === "INTERVIEW_EXPIRED"
    ) {
      setScheduledFlag(true);
    }
  }, [interviewState]);

  useEffect(() => {
    setCandidateName(interviewData?.candidateName);
    setCandidateEmail(interviewData?.candidateEmail);
    setExpiryDate(interviewData?.expiryDate);
  }, []);
  return (
    <div>
      <div className="px-[.8rem] py-[.3rem]">
        <div className="flex flex-col sm:gap-[.6rem] gap-[1.2rem] w-full lg:w-[92%] lg:pl-[.9rem]">
          <div className="flex sm:flex-row flex-col gap-[1.2rem]">
            <div className="sm:w-1/2 w-full">
              <div className="text-[#475467] font-medium text-[.9rem]">
                Name
              </div>
              <Input
                disabled={(scheduledFlag && !editFlag) || step3Enabled}
                className="rounded-[8px] mt-1 py-[.48rem]"
                placeholder="Enter name"
                value={candidateName}
                onChange={(e) => setCandidateName(e.target.value)}
              />
            </div>
            <div className="sm:w-1/2 w-full">
              <div className="text-[#475467] font-medium text-[.9rem]">
                Email
              </div>
              <Input
                disabled={(scheduledFlag && !editFlag) || step3Enabled}
                className="rounded-[8px] mt-1 py-[.48rem]"
                placeholder="Enter email"
                value={candidateEmail}
                onChange={(e) => setCandidateEmail(e.target.value)}
              />
            </div>
          </div>
          <div className="flex sm:flex-row flex-col gap-[1.2rem]">
            <div className="sm:w-1/2 w-full">
              <div className="text-[#475467] font-medium text-[.9rem]">
                Interview status
              </div>
              <Input
                disabled
                className="rounded-[8px] mt-1 py-[.48rem]"
                placeholder="Enter interview status"
                value={interviewState || "CONFIGURED"}
              />
            </div>
            <div className="sm:w-1/2 w-full">
              <div className="text-[rgb(71,84,103)] font-medium text-[.9rem]">
                Expiry date
              </div>
              <DatePicker
                disabled={(scheduledFlag && !editFlag) || step3Enabled}
                className="rounded-[8px] mt-1 py-[.48rem] w-full"
                value={expiryDate ? dayjs(expiryDate) : null}
                format="DD/MM/YYYY"
                disabledDate={disablePastDates}
                onChange={(date) => {
                  setExpiryDate(
                    date ? dayjs(date).format("YYYY-MM-DDTHH:mm:ss") : null
                  );
                }}
              />
            </div>
          </div>
          {editFlag ? (
            <div className="flex justify-end mt-[.32rem] gap-2 text-[.9rem]">
              <button
                className="btn-white px-[1.1rem] py-[.4rem] rounded-[6px]"
                onClick={() => setEditFlag(false)}
              >
                Cancel
              </button>
              <button
                className="btn-orange px-[1.2rem] py-[.4rem] rounded-[6px]"
                onClick={handleReSchedule}
              >
                Reschedule interview
              </button>
            </div>
          ) : scheduledFlag ? (
            <div className="flex flex-col items-end gap-1">
            {isExpired && (
              <div className="text-red-600 font-medium text-[.85rem]">
                This interview link expired on{" "}
                {formatDeadlineDay(
                  interviewData?.expiresAt,
                  interviewData?.expiryDate
                )}. Pick a new expiry
                date to reschedule.
              </div>
            )}
            <button
              className="btn-orange text-[.9rem] mt-[.32rem] px-[1.2rem] py-[.4rem] rounded-[6px] self-end"
              onClick={() => setEditFlag(true)}
            >
              Edit & Reschedule
            </button>
            </div>
          ) : (
            <button
              className={`${
                step3Enabled
                  ? "btn-disabled cursor-not-allowed "
                  : "btn-orange cursor-pointer "
              } text-[.9rem] mt-[.32rem] px-[1.2rem] py-[.4rem] rounded-[6px] self-end`}
              onClick={handleSchedule}
              disabled={step3Enabled}
            >
              Schedule interview
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CandidateInformation;
